import { Footer } from '@components/Footer'
import { Route } from '@components/NavigationButtonGroup'
import { ReadonlyURLSearchParams } from 'next/navigation'
import HoldingsList from '../HoldingsList'
import ErrorMessage from '@components/ErrorMessage'
import { useTranslation } from 'react-i18next'
import LoadingSpinner from '@components/LoadingSpinner'
import { Holding } from '@hooks/useHoldings'
import HoldingDetails from '../HoldingDetails'

type HoldingMainProps = {
  loading: boolean
  connected: boolean
  error: Error
  isAnyStaking: boolean
  holdings: Holding[]
  filteredHoldings: Holding[]
  params: ReadonlyURLSearchParams
  routes: Route[]
  selectedRoute: string
  selectHoldingHandler: (holding: Holding) => void
  selectRouteHandler: (route: string) => void
  stakeAllHandler: () => void
  onRetry: () => void
}

export default function Main({
  loading,
  connected,
  error,
  isAnyStaking,
  holdings,
  filteredHoldings,
  params,
  routes,
  selectedRoute,
  selectHoldingHandler,
  selectRouteHandler,
  stakeAllHandler,
  onRetry,
}: HoldingMainProps) {
  const { t } = useTranslation()

  return (
    <>
      <main className="w-screen flex flex-col justify-start px-4 gap-8 min-h-[90vh]">
        <div className="flex flex-col min-[430px]:flex-row justify-center min-[430px]:justify-between items-center">
          {(loading || error || !params.get('dewi')) && (
            <span className="mt-30">
              {/* <NavigationButtonGroup
                routes={routes}
                onClick={selectRouteHandler}
                selected={selectedRoute}
              /> */}
            </span>
          )}
          {/* {connected &&
            !loading &&
            !error &&
            selectedRoute === 'all' &&
            !params.get('dewi') && (
              <Button
                ripple
                className="mt-10 min-[430px]:mt-30"
                size="lg"
                onClick={stakeAllHandler}
              >
                {isAnyStaking
                  ? t('holdings.unstakeAll')
                  : t('holdings.stakeAll')}
              </Button>
            )} */}
        </div>
        <div className="flex justify-center items-center">
          {!connected ? (
            <ErrorMessage text={t('holdings.noWalletConnected')} />
          ) : loading ? (
            <LoadingSpinner />
          ) : error ? (
            <ErrorMessage onRetry={onRetry} />
          ) : holdings.length > 0 && !!params.get('dewi') ? (
            <>
              <HoldingDetails
                referral
                holdings={holdings}
                mint={params.get('dewi')}
              />
            </>
          ) : filteredHoldings.length === 0 ? (
            <ErrorMessage text={t('holdings.noNfts')} />
          ) : (
            <HoldingsList
              ripple
              holdings={filteredHoldings}
              onSelectHolding={selectHoldingHandler}
              stake
            />
          )}
        </div>
      </main>
      {connected && !loading && !error && filteredHoldings.length > 0 && (
        <Footer />
      )}
    </>
  )
}
